import { useMemo } from "react"
import { AuthUser } from "../domain/authUser"

// 正しい実装: https://github.com/auth0/jwt-decode/blob/master/lib/base64_url_decode.js
const decodeJwt = (token: string): AuthUser | undefined => {
    const base64Url = token.split(".")[1]
    if (base64Url) {
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
        return JSON.parse(decodeURIComponent(escape(window.atob(base64))))
    }
    return
}

export const useAuthUser = (token: string): AuthUser | undefined => {
    return useMemo(() => {
        try {
            return decodeJwt(token)
        } catch (err) {
            // ログインしていなくてトークンがないケースなどもあるので、特にエラーを出す必要はない
            return undefined
        }
    }, [token])
}
